import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import MessagesExpansionPanel from './Components/MessagesExpansionPanel';
import { MessageUpdateType } from './Mutations/MessageListUpdateMutation';
import { MessageDeleteType } from './Mutations/MessageListDeleteMutation';
import { IMessageParts } from './Utils/MessageUtils';
import EDAvenyProgress from '../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';

interface IProps {
  messages: IMessage[];
  messagesLoading: boolean;
  updateMessage: MessageUpdateType;
  delete: MessageDeleteType;
  classes?: any;
}

export interface IMessage {
  id: string;
  _version: number;
  title: string;
  createdDate: Date;
  parts: IMessageParts[];
  reciever: IReceiver;
}

interface IReceiver {
  id: string;
  _version: number;
  read: boolean;
}

const Styles = (theme: Theme) => ({
  messageContainer: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
  },
  notificationIcon: {
    position: 'absolute',
    right: 5,
  },
  messagePanelWrapper: {
    display: 'flex',
    flexFlow: 'row nowrap',
    marginBottom: 8,
    justifyContent: 'space-between',
    width: '100%',
  },
});

interface IState {
  expanded: boolean;
  openMessage?: string;
}

/**
 * En listkomponent som håller flera meddelanden.
 */
export class Messages extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      expanded: false,
      openMessage: undefined,
    };
  }

  togglePanels = (message: IMessage, read?: boolean) => {
    this.setState({
      openMessage: message.id,
    });

    this.setRead(message, read);
  };

  setRead = (message: IMessage, read?: boolean) => {
    this.props.updateMessage({
      id: message.reciever.id,
      _version: message.reciever._version,
      newReadStatus: read ?? !message.reciever.read,
    });
  };

  render() {
    return (
      <div className={this.props.classes.messageContainer}>
        {this.props.messagesLoading && <EDAvenyProgress />}
        {!this.props.messagesLoading &&
          this.props.messages.map(message => (
            <div
              key={message.id}
              className={this.props.classes.messagePanelWrapper}
            >
              <MessagesExpansionPanel
                expanded={
                  this.state.openMessage !== undefined &&
                  this.state.openMessage === message.id
                }
                message={message}
                onUpdate={this.togglePanels}
                toggleRead={this.setRead}
                delete={this.props.delete}
              />
            </div>
          ))}
      </div>
    );
  }
}

export default withStyles(Messages, Styles);
